import { FirebaseMapClientRepository } from "@data/repositories/index";
import { WatchMapClientsUseCase } from "@useCases/index";
import mapClientStore from "@data/stores/mapClient";
import userStore from "@data/stores/user";
import { useEffect } from "react";
import { useStore } from "zustand";

export default function useMapClients() {
  const { mapClients } = useStore(mapClientStore);

  const getMapClients = async () => {
    const useCase = new WatchMapClientsUseCase(
      userStore.getState(),
      new FirebaseMapClientRepository(mapClientStore.getState())
    );

    useCase.execute();
  };

  useEffect(() => {
    if (mapClients.length === 0) {
      getMapClients();
    }
  }, []);

  return {
    mapClients,
  };
}
